import Dialog from "@mui/material/Dialog";
import React, { useState, useEffect } from "react";

import { Grid, IconButton, Button, Typography, DialogTitle } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import format from "date-fns/format";
import isAfter from "date-fns/isAfter";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import AddIcon from "@mui/icons-material/Add";
import SelectComponent from "components/common/CommonSelect";
import { DATE_FORMAT_YMD_DISPLAY } from "constant";
import CloseIcon from "@mui/icons-material/Close";
import SystemMessageDialog from "components/common/SystemMessageDialog";
import { AccessQrCodeViewContext } from "components/accessQrCode/index";

const useStyles = makeStyles((theme) => ({
	dialog: {
		borderRadius: 0,
	},
	dialogPaper: {
		borderRadius: "10px !important",
	},
	title: {
		height: 40,
		paddingLeft: 20,
		fontSize: 13,
		color: "#f58220",
		backgroundColor: "#ffefe1",
	},
	red: {
		color: "#ff0000",
	},
	activeButton: {
		backgroundColor: "#f58220 !important",
		color: "#ffff !important",
		textTransform: "none !important",
	},
	label: {
		color: "#000",
		textAlign: "left",
	},
	dialogMargin: {
		margin: 15,
	},
}));

export default function AccessQrCodeMobile(props) {
	const {
		onClose,
		open,
		occupiedOpen,
		setOccupiedOpen,
		updateAlertOpen,
		setUpdateAlertOpen,
		project,
		projectList,
		remarks,
		token,
		refNum,
		handleSelect,
		optionsClick,
		isLocked,
		qrcodeImg,
	} = React.useContext(AccessQrCodeViewContext);

	const classes = useStyles();

	const renderQrCode = () => {
		return (
			<>
				<DialogTitle style={{ textAlign: "center", padding: "10px", position: "relative", width: "100%" }}>
					<Typography color={"primary"} style={{ fontSize: 25 }}>
						{"Access QR Code"}
					</Typography>
				</DialogTitle>
				<IconButton
					aria-label="close"
					style={{ position: "absolute", top: 5, right: 5, padding: 5, color: "#000" }}
					onClick={onClose}
					size="large"
				>
					<CloseIcon style={{ fontSize: 28 }} size="small" />
				</IconButton>
				<Grid container justifyContent={"center"} style={{ marginBottom: 10 }}>
					<SelectComponent
						displayEmpty={false}
						value={project}
						onChange={handleSelect}
						options={projectList}
						valueField={"projectId"}
						nameField={"refNum"}
						optionclick={optionsClick}
					/>
				</Grid>
				<Grid
					container
					justifyContent={"center"}
					style={{ padding: 10, display: token && !isLocked ? "flex" : "none" }}
				>
					{/* <canvas id="qrcode_canvas" style={{ borderRadius: 8, width: "100%" }}></canvas> */}
					<img style={{ borderRadius: 8, width: "100%" }} src={qrcodeImg} />
				</Grid>
				<Grid container justifyContent={"center"} style={{ fontSize: 13, fontWeight: 600 }}>
					{" "}
					Remarks:{" "}
				</Grid>
				<Grid container justifyContent={"center"} style={{ fontSize: 13, marginBottom: 10, fontWeight: 600 }}>
					{remarks}
				</Grid>
				<Grid
					container
					justifyContent={"center"}
					style={{ fontSize: 13, fontWeight: 600, textAlign: "center" }}
				>
					Please be reminded to sign out using QR code when you leave.
				</Grid>
			</>
		);
	};

	return (
		<>
			<Dialog
				open={open}
				disableEscapeKeyDown
				maxWidth="xs"
				className={classes.dialog}
				aria-labelledby="form-dialog-title"
				classes={{
					paper: classes.dialogMargin,
				}}
				PaperProps={{ classes: { root: classes.dialogPaper } }}
			>
				<Grid container style={{ padding: "5px 10px" }}>
					{renderQrCode()}
				</Grid>
			</Dialog>
			<SystemMessageDialog
				open={updateAlertOpen}
				onClose={() => {
					setUpdateAlertOpen(false);
					onClose();
				}}
			>
				<div>No seat has been reserved on {format(new Date(), DATE_FORMAT_YMD_DISPLAY)}.</div>
				<div>Please reserve your seat in Manage Bookings.</div>
			</SystemMessageDialog>
			<SystemMessageDialog
				open={occupiedOpen}
				onClose={() => {
					setOccupiedOpen(false);
				}}
			>
				<div>All reserved seat(s) for {refNum} is (are) occupied on </div>
				<div> {format(new Date(), DATE_FORMAT_YMD_DISPLAY)}.</div>
				<div>Please manage your seat in Manage Bookings. </div>
			</SystemMessageDialog>
		</>
	);
}
